/* eslint-disable prettier/prettier */
<template>
 <div>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100" >
        <md-card class="md-card-plain">
          <md-card-header>
            <h4 class="title"><b>Mayai customer detail</b></h4>
          </md-card-header>
          <md-card-content>
            <div style="width: 780px; margin: 35px auto 0;">
              <md-tabs class="md-success">
                <md-tab id="tab-home" md-label="Home" style="background-color: #eeeeee;">
                  <div style="display: flex; justify-content: space-between; flex-wrap: wrap; background-color: white;">
                    <h3 style="width: 100%;">基本情報</h3>
                    <div style="width: 33%;">
                      Company Name
                    </div>
                    <div style="width: 33%;">
                      050 Number
                    </div>
                     <div style="width: 33%;">
                      Login ID
                    </div>
                    <div style="width: 33%;">
                      Company Name
                    </div>
                    <div style="width: 33%;">
                      050 Number
                    </div>
                     <div style="width: 33%;">
                      Login ID
                    </div>
                  </div>
                  <div style="display: flex; justify-content: space-between; flex-wrap: wrap; padding: 8px 0;">
                    <div style="width: 30%; background-color: white;">
                      Company Name
                    </div>
                    <div style="width: 30%; background-color: white;">
                      050 Number
                    </div>
                     <div style="width: 30%; background-color: white;">
                      Login ID
                  </div>
                  </div>
                  <div style="display: flex; justify-content: space-between; flex-wrap: wrap; background-color: white;">
                    <h3 style="width: 100%;">その他</h3>
                    <div style="width: 33%;">
                      Company Name
                    </div>
                    <div style="width: 33%;">
                      050 Number
                    </div>
                     <div style="width: 33%;">
                      Login ID
                    </div>
                    <div style="width: 33%;">
                      Company Name
                    </div>
                    <div style="width: 33%;">
                      050 Number
                    </div>
                     <div style="width: 33%;">
                      Login ID
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
  <div class="loading-overlay" v-if="loading">
      <md-progress-spinner
        md-mode="indeterminate"
        :md-stroke="2"
      ></md-progress-spinner>
    </div>
  </div>
</template>

<script>
// import { SimpleTable} from "@/components";
import ApiService from "@/services/ApiService";
// import EditMayaiStatus from "../components/EditMayaiStatus";

export default {
  // components: {
  //   EditMayaiStatus
  // },
  props: {
    tableHeaderColor: {
      type: String,
      default: "green"
    }
  },
  data() {
    return {
      loading: false,
      companies: [],
      active: 0,
      inactive: 0,
      isEditStatus: false,
      selectedCompany: {
        name: "",
        _id: "",
        status: ""
      },
      selectedIndex: -1,
      editedItems: []
    };
  },
  mounted() {
    this.fetchCustomer();
  },
  methods: {
    async fetchCustomer() {
      this.loading = true;
      var responce = await ApiService.fetchMayaiCustomers();
      // console.log(responce);
      this.active = 0;
      if (responce.data) {
        this.loading = false;
        this.companies = responce.data.customers;
        await this.companies.forEach(async comp => {
          if (comp.status === "active") {
            this.active++;
          } else if (comp.status === "inactive") {
            this.inactive++;
          }
        });
      } else {
        this.loading = false;
      }
    },

    sleep(index) {
      console.log("Sleep clicked for " + index );
      // console.log(this.companies[index]);
      this.save(index, "sleep");
    },

    cancel(index) {
      console.log("Cancel clicked for " + index );
      // console.log(this.companies[index]);
      this.save(index, "cancel");
    },

    async save(index, status) {
      console.log("Save edited companies");
      var company = this.companies[index];
      var params = {
        company_id: company._id,
        status: status
      };
      var response = await ApiService.update_mayai_status(params);
      if (response.status === 200) {
        this.notifyVue("top", "center", "Status updated", "success");
        this.fetchCustomer();
      } else {
        this.notifyVue(
          "top",
          "center",
          "Status could not be updated",
          "warning"
        );
      }
    },

    notifyVue(verticalAlign, horizontalAlign, message, type) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    }
  }
};
</script>


<style lang="scss">
.md-tabs-navigation {
  background: transparent !important;
  box-shadow: none !important;
  .md-button-content {
    color: black !important;
  } 
} 

.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
  }

  .loading-overlay {
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
